import React from "react";
import { createPortal } from "react-dom";
import ClosingButton from "../Buttons/ClosingButton";
import Button from "../Buttons/Button";
import "../../css/Modal.css";

// Keys must match DEAL_ALERT_FONT_KEYS in api/routes/userData.js — the server
// only ever stores one of these keys, never a raw CSS value.
export const DEAL_ALERT_FONTS = {
  default: { label: "Default (site font)", css: "" },
  serif: { label: "Serif (Georgia)", css: "Georgia, 'Times New Roman', Times, serif" },
  times: { label: "Times New Roman", css: "'Times New Roman', Times, serif" },
  arial: { label: "Arial", css: "Arial, Helvetica, sans-serif" },
  verdana: { label: "Verdana", css: "Verdana, Geneva, sans-serif" },
  trebuchet: { label: "Trebuchet MS", css: "'Trebuchet MS', sans-serif" },
  courier: { label: "Courier New (monospace)", css: "'Courier New', Courier, monospace" },
  comic: { label: "Comic Sans MS", css: "'Comic Sans MS', 'Comic Sans', cursive" },
};

// Renders the welcome/deal popup — shared by the live WelcomeModal and the
// admin "Preview" button so what admins see while editing is pixel-for-pixel
// what visitors get.
export default function PopupModal({ popup, onClose, onCtaClick, usePortal = true }) {
  if (!popup) return null;

  const fontCss = DEAL_ALERT_FONTS[popup.fontFamily]?.css || "";

  const content = (
    <div className="modal welcome-modal">
      <div className="modal-content modal-card" style={fontCss ? { fontFamily: fontCss } : undefined}>
        <div className="modal-grid">
          <div className="modal-header">
            <div className="back-slot"></div>
            <h2 className="share-modal-title">{popup.title || "Untitled popup"}</h2>
            <div className="close-slot">
              <ClosingButton onClick={onClose} />
            </div>
          </div>

          <div className="modal-body">
            <div className="form-container">
              <div className="welcome-body">
                <div
                  className="welcome-rich-content"
                  dangerouslySetInnerHTML={{ __html: popup.message || "" }}
                />

                {popup.showPromo !== false && (popup.promoTitle || popup.promoCode) && (
                  <div className="welcome-promo-box">
                    {popup.promoTitle && (
                      <p className="welcome-promo-title">{popup.promoTitle}</p>
                    )}
                    {popup.promoCode && (
                      <p className="welcome-promo-code">
                        Use promo code <strong className="welcome-code">{popup.promoCode}</strong>
                        {popup.promoSuffix ? ` ${popup.promoSuffix}` : ""}
                      </p>
                    )}
                  </div>
                )}

                {popup.showButton !== false && (
                  <div className="welcome-actions">
                    <Button
                      className="auth-form__btn auth-form__btn--solid welcome-btn"
                      onClick={onCtaClick}
                    >
                      {popup.ctaText || "Got it"}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-actions" />
        </div>
      </div>
    </div>
  );

  return usePortal ? createPortal(content, document.body) : content;
}
